import { format, LoggerOptions } from "winston";

const winstonConfig: LoggerOptions = {
	format: format.combine(format.timestamp({ format: "YYYY-MM-DD HH:mm:ss.SSSZ" })),
	level: "debug",
	levels: {
		error: 0,
		warn: 1,
		// The level "log" conflicts with Winston's log method.
		"log-": 2,
		info: 3,
		debug: 4,
		verbose: 5,
	},
};

export default winstonConfig;
